import { makeAutoObservable } from 'mobx';
import { RootStore, ServiceStore } from '@intrasync/stores';
import { utils } from 'shared/intrasyncUtils';
import { getDateRange } from 'shared/intrasyncUtils';
import HardwareScheduleRightHeaderCell from './HardwareOverviewCells/HardwareOverview.RightHeaderCell';
import HardwareScheduleRightBodyCell from './HardwareOverviewCells/HardwareOverview.RightBodyCell';
import HardwareScheduleLeftHeaderCell from './HardwareOverviewCells/HardwareOverview.LeftHeaderCell';
import HardwareScheduleLeftBodyCell from './HardwareOverviewCells/HardwareOverview.LeftBodyCell';

class HardwareOverviewScheduleStore {
    hiddenColumns: number[] = [];
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setHiddenColumn = (columnIndex: number) => {
        if (this.hiddenColumns.includes(columnIndex)) {
            this.hiddenColumns = this.hiddenColumns.filter(
                (column) => column !== columnIndex
            );
            return;
        }
        this.hiddenColumns.push(columnIndex);
    };

    get jobNumbersWithinDateInRange() {
        const routerStore = this.rootStore.routerStore;
        if (!routerStore?.queryParams) return [];
        const { startDate, endDate } = routerStore.queryParams as {
            startDate: string;
            endDate: string;
        };

        const filteredJobNumbers = this.allEntities
            .filter(
                (entity) =>
                    entity.dateReceived &&
                    entity.jobNumber &&
                    entity.dateReceived >= startDate &&
                    entity.dateReceived <= endDate
            )
            .map((entity) => entity.jobNumber as number);

        const currentEntitiesJobNumbers = utils.uniqueArray(
            filteredJobNumbers
        ) as number[];
        return currentEntitiesJobNumbers.sort((a, b) => a - b);
    }

    get columnHeaders() {
        const headersByJobNumber = this.jobNumbersWithinDateInRange
            .filter((jobNumber) => {
                return this.jobNumbersWithinDateInRange.includes(jobNumber as number);
            })
            .filter((jobNumber) => {
                return !this.hiddenColumns.includes(jobNumber);
            })
            .map((jobNumber) => {
                return {
                    width: 200,
                    title: jobNumber.toString(),
                    key: jobNumber,
                    headerKey: 'jobNumber',
                    component: HardwareScheduleRightHeaderCell,
                    bodyComponent: HardwareScheduleRightBodyCell,
                };
            });

        return [
            {
                width: 200,
                title: 'Date',
                key: 'orderDate',
                component: HardwareScheduleLeftHeaderCell,
                bodyComponent: HardwareScheduleLeftBodyCell,
            },
            ...headersByJobNumber,
        ];
    }

    get allEntities() {
        const hardwareOrdersStore = this.rootStore.hardwareOrdersStore as ServiceStore;
        return hardwareOrdersStore.entities || [];
    }

    get entities() {
        console.log('HardwareOverviewScheduleStore entities');
        if (!this.allEntities) {
            console.log('HardwareOverviewScheduleStore entities no allEntities');
            return [];
        }
        const currentEntities = this.allEntities.filter((entity) => {
            // Skip entries with invalid dates
            if (entity.dateReceived === '1970-01-01') return false;

            return this.jobNumbersWithinDateInRange.includes(
                entity.jobNumber as number
            );
        });
        console.log('HardwareOverviewScheduleStore entities', currentEntities);
        return currentEntities;
    }

    get dateRange() {
        console.log('HardwareOverviewScheduleStore dateRange');
        const routerStore = this.rootStore.routerStore;
        if (!routerStore?.queryParams) return [];
        const { startDate, endDate } = routerStore.queryParams as {
            startDate: string;
            endDate: string;
        };

        const currentDateRange = getDateRange(startDate, endDate, { weekdays: true });
        console.log('HardwareOverviewScheduleStore dateRange dates', currentDateRange);
        return currentDateRange;
    }
}

export default HardwareOverviewScheduleStore;